import React, { useContext, useMemo, useState } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierNotesPanel from '../components/panels/CarrierNotesPanel';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierNotesPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();
  const [headerActions, setHeaderActions] = useState(null);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'notesPermission');

  const content =
    canView && (
      <>
        <StickyPageHeader
          actions={headerActions}
          subtitle={selectedCarrier.name}
          title="Notes"
        />
        <CarrierNotesPanel
          carrier={selectedCarrier}
          id="notes"
          onHeaderActions={setHeaderActions}
        />
      </>
    );

  if (disableLayout) {
    return content || null;
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierNotesPage;
